import { CheckCircle2, Circle, Loader2, XCircle } from "lucide-react";

const STEPS = [
  { key: "scripting",             label: "01  Drafting Screenplay",   detail: "GPT is composing your title, logline, and per-scene shot notes." },
  { key: "generating_video",      label: "02  Rendering the Frames",   detail: "Flux paints each scene, ffmpeg breathes motion into the stills." },
  { key: "generating_voiceover",  label: "03  Recording Voiceover",   detail: "OpenAI TTS is reading your narration." },
  { key: "scoring",               label: "04  Scoring the Film",      detail: "Fading a mood-matched instrumental bed under the voice." },
  { key: "complete",              label: "05  Final Cut",             detail: "Picture, voice and music married. Ready to screen." },
];

const ORDER = ["queued", "scripting", "generating_video", "generating_voiceover", "scoring", "complete"];

function statusOf(current, key) {
  if (current === "failed") return "failed";
  const ci = ORDER.indexOf(current);
  const ki = ORDER.indexOf(key);
  if (ci > ki) return "done";
  if (ci === ki) return "active";
  return "pending";
}

export default function GenerationProgress({ movie }) {
  const current = movie?.status || "queued";
  const failed = current === "failed";

  return (
    <div
      data-testid="generation-progress"
      className="relative border border-white/10 bg-[#0A0A0A] p-8 md:p-12"
    >
      <div className="mb-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="inline-block h-2.5 w-2.5 rounded-full bg-[#E50914] rec-dot" />
          <span className="font-mono-ui text-xs uppercase tracking-[0.28em] text-white/60">
            {failed ? "Take Failed" : "Now Filming"}
          </span>
        </div>
        <span className="font-mono-ui text-xs uppercase tracking-[0.28em] text-white/40">
          ID · {movie?.id?.slice(0, 8)}
        </span>
      </div>

      <div className="space-y-6">
        {STEPS.map((s) => {
          const st = statusOf(current, s.key);
          return (
            <div key={s.key} className="flex items-start gap-5" data-testid={`step-${s.key}`}>
              <div className="pt-1">
                {failed && st === "active" ? (
                  <XCircle className="h-5 w-5 text-[#E50914]" strokeWidth={1.5} />
                ) : st === "done" ? (
                  <CheckCircle2 className="h-5 w-5 text-white" strokeWidth={1.5} />
                ) : st === "active" ? (
                  <Loader2 className="h-5 w-5 animate-spin text-[#E50914]" strokeWidth={1.5} />
                ) : (
                  <Circle className="h-5 w-5 text-white/25" strokeWidth={1.5} />
                )}
              </div>
              <div className="flex-1 border-b border-white/5 pb-6 last:border-b-0 last:pb-0">
                <div className="font-mono-ui text-sm tracking-widest text-white">
                  {s.label}
                </div>
                <div className={`mt-1 text-sm ${st === "active" ? "text-white/80" : "text-white/40"}`}>
                  {st === "active" && movie?.progress_message ? movie.progress_message : s.detail}
                  {st === "active" && <span className="caret ml-1">▍</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {failed && (
        <div className="mt-8 border border-[#E50914]/40 bg-[#E50914]/5 p-5 font-mono-ui text-sm text-[#ff6b73]">
          <div className="mb-1 uppercase tracking-widest">Error</div>
          <div className="text-white/70">{movie?.error || "Something went wrong."}</div>
        </div>
      )}
    </div>
  );
}
